module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921055649_T.24050e11.jpg";